// html-decoder.service.ts
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class HtmlDecoderService {
  private decoderElement: HTMLTextAreaElement = document.createElement('textarea');

  decodeHtmlEntities(str: string): string {
    this.decoderElement.innerHTML = str;
    return this.decoderElement.value;
  }
}
